import React from "react";
import {
  ArrowLeft,
  Check,
  CircleHelp,
  List,
  MoreHorizontal,
  Pencil,
  X,
} from "lucide-react";
import { RequestItem } from "../../../api/requests";
import { CircularProgress } from "../../../components/CircularProgress/CircularProgress";

export interface RequestDetailTopBarProps {
  loading: boolean;
  data: RequestItem | null;
  isEditingRequest: boolean;
  requestEditLoading: boolean;
  scheduling: boolean;
  scheduleDisabled: boolean;
  isActionsMenuOpen: boolean;
  canEditRequest: boolean;
  hasSchedule: boolean;
  canScanBySchedule: boolean;
  hasTaskItems: boolean;
  actionsMenuRef: React.RefObject<HTMLDivElement>;
  setIsActionsMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  handleBack: () => void;
  handleSaveRequestEdit: () => void;
  handleCancelRequestEdit: () => void;
  handleSchedule: () => void;
  handleStartRequestEdit: () => void;
  handleOpenChecksModal: () => void;
  handleOpenScheduleModal: () => void | Promise<void>;
  handleOpenTaskListModal: () => void;
}

export const RequestDetailTopBar: React.FC<RequestDetailTopBarProps> = ({
  loading,
  data,
  isEditingRequest,
  requestEditLoading,
  scheduling,
  scheduleDisabled,
  isActionsMenuOpen,
  canEditRequest,
  hasSchedule,
  canScanBySchedule,
  hasTaskItems,
  actionsMenuRef,
  setIsActionsMenuOpen,
  handleBack,
  handleSaveRequestEdit,
  handleCancelRequestEdit,
  handleSchedule,
  handleStartRequestEdit,
  handleOpenChecksModal,
  handleOpenScheduleModal,
  handleOpenTaskListModal,
}) => (
  <div className="detail-top-bar">
    <button className="detail-back" onClick={handleBack}>
      <ArrowLeft size={20} />
      <span>Назад</span>
    </button>
    {!loading && data && (
      <div className="detail-top-actions">
        {isEditingRequest ? (
          <>
            <button
              type="button"
              className="detail-schedule-btn detail-schedule-btn--icon"
              onClick={handleSaveRequestEdit}
              disabled={requestEditLoading}
              aria-label="Сохранить заявку"
              title="Сохранить"
            >
              <Check size={18} />
            </button>
            <button
              type="button"
              className="detail-schedule-btn detail-schedule-btn--icon"
              onClick={handleCancelRequestEdit}
              disabled={requestEditLoading}
              aria-label="Отменить редактирование"
              title="Отменить"
            >
              <X size={18} />
            </button>
          </>
        ) : (
          <>
            <button
              className="detail-schedule-btn detail-schedule-btn--top"
              onClick={handleSchedule}
              disabled={scheduleDisabled}
            >
              {scheduling ? <CircularProgress size="sm" /> : "Запустить проверку"}
            </button>
            <div className="detail-actions-menu" ref={actionsMenuRef}>
              <button
                type="button"
                className="detail-schedule-btn detail-schedule-btn--icon"
                onClick={() => setIsActionsMenuOpen((prev) => !prev)}
                aria-label="Открыть действия"
                title="Действия"
              >
                <MoreHorizontal size={18} />
              </button>
              {isActionsMenuOpen && (
                <div className="detail-actions-menu-panel">
                  {canEditRequest && (
                    <button
                      type="button"
                      className="detail-actions-menu-item"
                      onClick={handleStartRequestEdit}
                    >
                      <Pencil size={16} />
                      <span>Редактировать заявку</span>
                    </button>
                  )}
                  <button
                    type="button"
                    className="detail-actions-menu-item"
                    onClick={handleOpenChecksModal}
                  >
                    <CircleHelp size={16} />
                    <span>Список проверок</span>
                  </button>
                  {canScanBySchedule ? (
                    <button
                      type="button"
                      className="detail-actions-menu-item"
                      onClick={handleOpenScheduleModal}
                    >
                      <MoreHorizontal size={16} />
                      <span>{hasSchedule ? "Настроить расписание" : "Создать расписание"}</span>
                    </button>
                  ) : null}
                  {hasTaskItems && (
                    <button
                      type="button"
                      className="detail-actions-menu-item"
                      onClick={handleOpenTaskListModal}
                    >
                      <List size={16} />
                      <span>Список задач</span>
                    </button>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    )}
  </div>
);
